module.exports = __webpack_public_path__ + "static/img/BOSTON_MAPLE.f1118ca.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/materials/Frendel/BOSTON_MAPLE.jpg
// module id = VQJG
// module chunks = 0